import React, { FC } from 'react';
import s from './Templates.module.css';
import facebook_icon from '../../../assets/img/facebook.svg';
import linkedin_icon from '../../../assets/img/linkedin.svg';
import instagram_icon from '../../../assets/img/instagram.svg';
import twitter_icon from '../../../assets/img/twitter.svg';
import reddit_icon from '../../../assets/img/reddit.svg';
import threads_icon from '../../../assets/img/threads.svg';
import { Template } from '../../../store/slices/templatesSlice';

interface TemplatesProps {
    currentTemplate: Template | null;
    handleTemplateSelection: (template: Template) => void;
    sizeContainer?: 'small' | 'big';
}

const Templates: FC<TemplatesProps> = ({
    currentTemplate,
    handleTemplateSelection,
    sizeContainer = 'big',
}) => {
    const templates: Template[] = [
        { title: 'Threads', icon: threads_icon, tag: 'threads' },
        { title: 'Linkedin', icon: linkedin_icon, tag: 'linkedin' },
        { title: 'Instagram', icon: instagram_icon, tag: 'instagram' },
        { title: 'Facebook', icon: facebook_icon, tag: 'facebook' },
        { title: 'Twitter', icon: twitter_icon, tag: 'twitter' },
        { title: 'Reddit', icon: reddit_icon, tag: 'reddit' },
    ];

    console.log(currentTemplate);

    return (
        <div className={`${s.templates_container} ${s[sizeContainer]}`}>
            {templates.map((template) => (
                <div
                    onClick={() => handleTemplateSelection(template)}
                    className={`
                        ${s.template_card} 
 
                        ${s[sizeContainer]} 
                        ${currentTemplate?.tag.toLowerCase() === template.tag ? s.active : ''}
                    `}
                >
                    <img src={template.icon} alt={template.title} className={s.template_image} />
                    <span className={s.template_title}>{template.title}</span>
                </div>
            ))}
        </div>
    );
};

export default Templates;
